{
  "add_follow_up": "Add follow up",
  "email_sequence_cancel": "Stop",
  "email_sequence_cancel_confirmation": "The remaining follow-ups will not be sent. Stop this sequence?",
  "email_sequence_details_title": "Email sequence",
  "email_sequence_email_position": "This is email {current} of {total}",
  "email_sequence_next_send": "Next planned email: {date}",
  "email_sequence_next_send_interval": "Next planned email: between {date_from} and {date_to}",
  "email_sequence_next_send_interval_same_day": "Next planned email: {date}, from {time_from} to {time_to}",
  "email_sequence_status_active": "Active",
  "email_sequence_status_canceled": "Canceled manually",
  "email_sequence_status_completed": "Completed",
  "email_sequence_status_failed": "Failed",
  "email_sequence_status_replied": "Stopped after reply",
  "email_sequence_stopped": "{reason}: {date}",
  "email_status_pending": "Email pending",
  "email_status_canceled": "Email canceled",
  "email_status_failed": "Email failed",
  "email_integration_expired_error_with_link": "This email address connection expired. Please <reconnect>reconnect</reconnect> to continue sending emails.",
  "email_integration_missing_title": "No email connected",
  "email_integration_missing_description": "Please connect email account to send emails from %APP_NAME%",
  "first_message": "First message",
  "flow_after_last_message": "{count}d after the last message",
  "flows_have_errors": "Some follow-ups have errors. Please check them",
  "follow_up_delay": "Send after (calendar days)",
  "follow_up_delay_error": "Delay must be between 1 and 30 calendar days",
  "follow_up_limit_error": "You can add up to 5 follow-ups",
  "follow_ups_description": "Follow-ups are sent in the same thread with the same subject. A candidate reply stops the sequence",
  "follow_ups_immutable_description": "Once the sequence starts, its follow-up steps cannot be changed",
  "action_assigned": "Assigned",
  "action_created": "Created",
  "last_action_period": "Last action period",
  "action_disqualified": "Disqualified",
  "action_email_candidate_replied": "Candidate replied",
  "action_merged": "Merged",
  "action_qualified": "Qualified",
  "action_reserved": "Reserved",
  "active_my_jobs": "Active jobs",
  "add_candidate": "Add candidate",
  "add_notes": "Add notes",
  "add_recruiter": "Add recruiter",
  "add_stakeholder": "Add stakeholder or teammate",
  "additional_contacts": "Additional contacts",
  "additional_education": "Additional education",
  "ai_feature_title": "Recruiting AI",
  "all_jobs": "All jobs",
  "as_it_was_uploaded": "As it was uploaded",
  "assign_to_job": "Assign to job",
  "ats_description": "Track job candidates from application to hiring decisions",
  "authors": "Who added candidate",
  "avg_days_to_close": "Average days to close",
  "avg_on_stage_time": "Average on stage time",
  "avg_time": "Average time",
  "between_15_21_days": "15–21 days",
  "between_22_30_days": "22–30 days",
  "between_2_4_days": "2–4 days",
  "between_5_7_days": "5–7 days",
  "between_8_14_days": "8–14 days",
  "broaden_the_filter": "Broaden the filter",
  "candidate": "Candidate",
  "candidate_for": "Candidate for {job_info}",
  "candidates": "Candidates",
  "candidates_all": "All candidates",
  "candidates_all_active": "All active",
  "career_sites": "Career pages",
  "career_sites_settings_description": "Manage career sites with your active jobs",
  "certificates": "Certificates",
  "change_stage": "Change stage",
  "choose_disqualification_reason": "Choose disqualification reason",
  "choose_stage": "Choose stage",
  "chrome_extension": "Chrome extension",
  "create_offer": "Create offer",
  "create_page": "Create new page",
  "creation_date": "Job created",
  "cv_added": "CV added. Source — {source}",
  "cv_hide_all_description": "Name, photo, contact info, location and other personal data will be hidden",
  "cv_hide_other": "Hide personal info",
  "cv_hide_salary": "Hide salary",
  "cv_hide_salary_description": "No mention of salary or compensation",
  "cv_text": "CV text",
  "cv_text_enter": "Enter CV text",
  "cv_updated_at": "Updated",
  "delete_candidate_confirm_description": "Deleting the candidate will also remove all associated candidates on vacancies",
  "did_not_find_anyone": "We didn’t find anyone matching the selected filters",
  "duplicate_job": "Duplicate job",
  "duplicate_job_confirm": "A draft copy of this job will be created.",
  "disqualification": "Disqualification",
  "disqualification_reason": "Disqualification reason",
  "disqualification_reason_delete_confirm": "Do you want to remove reason?",
  "disqualification_reason_delete_confirm_description": "If you remove this reason all candidates which have disqualification for this reason will be qualified",
  "disqualification_reasons": "Disqualification reasons",
  "disqualified": "Disqualified",
  "disqualify": "Disqualify",
  "disqualify_and_reserve": "Disqualify & reserve",
  "edit_cv_text": "Edit CV text",
  "edit_job": "Edit job",
  "edit_offer": "Edit offer",
  "education": "Education",
  "experience": "Experience",
  "filter_candidates": "Filter candidates",
  "filter_date_candidate_birth_from": "Candidate birth date from",
  "filter_date_candidate_birth_to": "Candidate birth date to",
  "filter_last_action_from": "Last action from",
  "filter_last_action_to": "Last action to",
  "gt_30_days": "> 30 days",
  "hide_candidates_salary_info": "Hide candidates salary info",
  "hide_candidates_salary_info_caption": "Hiding may not work if user has access via privacy",
  "hide_candidates_salary_info_caption_settings": "settings",
  "hire_candidate": "Hire candidate",
  "hired_candidates": "Hired candidates",
  "interview": "Interview",
  "invite_candidate": "Invite candidate",
  "job": "Job",
  "job_archiving_reason": "Job closure reason",
  "job_archiving_reasons": "Job closure reasons",
  "job_enter_description": "Enter details for your next job opening, including all available information",
  "job_offer_request": "Job offer request",
  "job_offers": "Job offers",
  "job_priority": "Priority",
  "job_priority_high": "High",
  "job_priority_low": "Low",
  "job_priority_medium": "Medium",
  "job_priority_not_defined": "Not defined",
  "job_requirements_description": "Add the must-haves for your ideal candidate. The more specific you are, the smarter the AI match will be",
  "job_requirements_title": "Job requirements",
  "job_saved": "Job opening saved successfully",
  "job_select_team": "Assign teammates to collaborate on this job opening",
  "job_status_archived": "Archived",
  "job_status_draft": "Draft",
  "job_status_on_hold": "On hold",
  "job_status_published": "Active",
  "job_summary": "Job summary",
  "job_title": "Job title",
  "jobs": "Jobs",
  "jobs_closed_with_hire": "Jobs closed with hire",
  "jobs_filtered_by_selected_recruiters": "Job list is filtered by selected recruiters",
  "join_us": "Join us",
  "join_us_as": "Join us as {jobTitle}",
  "lte_1_day": "≤ 1 day",
  "make_mandatory": "Make mandatory",
  "make_optional": "Make optional",
  "managed_by": "Managed by",
  "max_salary": "Max salary",
  "merge_with": "Merge with",
  "merge_with_candidate": "Merge with candidate",
  "merge_with_description": "Find the candidate whose profile is a duplicate of this one. Next, you will compare the profiles and decide whether to merge them.",
  "min_salary": "Min salary",
  "move_to_next_stage": "Move to next stage",
  "move_to_stage_confirm": "Move the candidate to the «{stage}» stage?",
  "multiple_emails": "<Multiple emails>",
  "my_active_jobs": "My active jobs",
  "my_candidates": "My candidates",
  "my_candidates_description": "Candidates you assigned to positions",
  "my_jobs": "My jobs",
  "new_feature_ats_stage_flow_funnel": "New conversion settings in the Hiring pipeline report",
  "no_jobs_assigned": "No jobs assigned",
  "no_rejected_duplicates": "No rejected duplicates",
  "no_time_limit": "No time limit",
  "notification_settings_comments_caption": "When somebody comments on a candidate for your job",
  "notification_settings_mentions_caption": "When somebody @mentions you",
  "offer": "Offer",
  "offer_created": "Offer created",
  "offer_details": "Offer details",
  "offer_salary_annual_gross": "Annual gross",
  "offer_salary_annual_net": "Annual net",
  "offer_salary_monthly_gross": "Monthly gross",
  "offer_salary_monthly_net": "Monthly net",
  "offer_text": "Offer text",
  "offer_visibility": "Offer visibility",
  "offer_waiting_for_approval": "Offer is waiting for approval",
  "offer_waiting_for_your_approval": "Offer is waiting for your approval",
  "organization_invites": "{organization} invites",
  "overdue": "Overdue",
  "overdue_standard_time": "Standard time",
  "permissions_delete_all_comments": "Delete all comments",
  "permissions_delete_all_comments_description": "Allows to delete comments of others",
  "permissions_delete_candidates": "Delete candidates",
  "permissions_delete_candidates_description": "Allows to delete candidates from database",
  "permissions_manage_candidates": "Manage candidates",
  "permissions_manage_candidates_description": "Assign candidates to jobs, change stages etc.",
  "permissions_manage_career_sites": "Manage career sites",
  "permissions_manage_career_sites_description": "Selecting this option grants access to managing career sites",
  "permissions_manage_disqualification_reasons_description": "Manage disqualification reasons for candidate rejection",
  "permissions_manage_job_archiving_reasons_description": "Manage job archiving reasons for archiving jobs",
  "permissions_manage_jobs": "Manage jobs",
  "permissions_manage_jobs_description": "Create and edit any visible job",
  "permissions_manage_offers": "Manage offers",
  "permissions_manage_pipelines_description": "Manage recruitment pipelines, including stages",
  "permissions_manage_sources_description": "Manage and edit recruitment sources for job candidates",
  "permissions_manage_tags_description": "Manage tags to distinct candidates by skills, experience etc.",
  "permissions_reporting_hiring_pipeline_description": "View hiring pipeline report",
  "permissions_reporting_recruiting_closing_time_description": "View closing time report",
  "permissions_reporting_recruiting_disqualification_reasons_description": "View disqualification reasons report",
  "permissions_reporting_recruiting_source_efficiency_description": "View source efficiency report",
  "permissions_see_original_resume": "See original resume",
  "permissions_see_original_resume_description": "View the original resume submitted by the candidate",
  "permissions_show_all_candidates": "Show all candidates",
  "permissions_show_all_candidates_description": "Access to all candidates and their profiles",
  "permissions_show_all_jobs": "Show all jobs",
  "permissions_show_all_jobs_description": "If disabled - only assigned jobs will be visible",
  "permissions_show_candidate_salary": "Show candidate salary",
  "permissions_show_candidate_salary_description": "Viewing salary information of candidates",
  "permissions_show_offers_salary": "Show offer salary",
  "permissions_show_offers_salary_description": "If selected, salary will be shown in all visible job offers",
  "permissions_show_salary": "Show job salary",
  "permissions_show_salary_description": "If selected job salary will be shown for all visible jobs",
  "pipeline": "Pipeline",
  "pipeline_default": "Default pipeline",
  "pipeline_stage_applied": "All new candidates start here. This is a system status and cannot be deleted",
  "pipeline_stage_hired": "The candidate has completed all stages of the recruitment process and accepted the job offer. The onboarding process begins. This is a system status and cannot be deleted",
  "pipeline_stage_offer": "The candidate has passed all interviews and assessments and has been given a job offer. This is a system status and cannot be deleted",
  "pipelines": "Pipelines",
  "pipelines_description": "Manage the stages of your recruitment process from initial application to final hire",
  "pipelines_select_stages_description": "Stage order is managed in the 'Stages' section. To add a new stage, first add it to the 'Stages' section, then activate the checkbox",
  "pipelines_select_stages_title": "Select the stages to be included in the pipeline",
  "planned_start": "Planned start",
  "potential_threat": "Potential threat",
  "potential_threat_default": "This candidate's profile has signs that require additional review.",
  "potential_threat_mixed_characters": "Mixed Cyrillic and Latin characters detected in the candidate’s name. This pattern may indicate an attempt to create alternative identities.",
  "potential_threat_ai_generated_cv": "This resume looks like it was put together with AI assistance. That is not a violation in itself and says nothing about the candidate's qualifications. Keep in mind the wording may describe experience in general terms — it is worth asking about specifics during the interview.",
  "potential_threat_ai_generated_cv_tag": "AI text detected",
  "potential_threat_ai_generated_cv_beta": "Beta",
  "potential_threat_ai_generated_cv_disclaimer": "This check is in testing and can be wrong.",
  "prepare_your_pdf": "Prepare your PDF",
  "prepare_your_word_file": "Prepare your word file",
  "preview_offer": "Preview offer",
  "public_title": "Public job name",
  "public_title_information": "If you don’t enter this title, the main job title will be displayed on the career site",
  "publish_jobs_to_career_pages": "Publish your active jobs to automatically generated career pages",
  "recruit": "Recruit",
  "recruit_module": "Recruit module",
  "recruit_module_description": "Grant access to recruit section of platform. Employees without this permission will not see jobs and candidates assigned to them",
  "recruiter": "Recruiter",
  "recruiters": "Recruiters",
  "recruiters_involved": "Recruiters involved",
  "rejected_duplicates": "Rejected duplicates",
  "rejected_duplicates_description": "Candidates marked as different people when reviewing duplicates.",
  "rejected_duplicates_return_hint": "If this was a mistake, return the candidate to duplicates: if the profiles are similar, the merge will be suggested again.",
  "remove_from_job": "Remove from job",
  "report_closing_time": "Closing time",
  "report_closing_time_description": "Track average time from application to job offer by position",
  "report_closing_time_title": "Closing time report",
  "report_disqualification_reason_table_description": "Breakdown of reasons for candidate disqualification during the hiring process",
  "report_disqualification_reason_table_title": "Candidate disqualification analysis",
  "report_disqualification_reason_total_candidates": "Disqualified candidates",
  "report_disqualification_reason_totals_table_title": "Disqualification reasons totals",
  "report_disqualification_reasons": "Disqualification reasons",
  "report_disqualification_reasons_description": "See why candidates were not selected at each hiring stage",
  "report_disqualification_reasons_title": "Disqualification reasons report",
  "report_hiring_pipeline": "Hiring pipeline",
  "report_hiring_pipeline_description": "See how candidates move through each recruitment stage",
  "report_hiring_pipeline_title": "Hiring pipeline report",
  "report_source_efficiency": "Source efficiency",
  "report_source_efficiency_table_description": "Number of candidates at each stage over time period",
  "report_source_efficiency_table_title": "Candidates at stages by hiring sources",
  "report_source_efficiency_title": "Source efficiency report",
  "reserved": "Reserved",
  "resume": "Resume",
  "resume_files_cta": "CV files",
  "return_to_duplicates": "Return to duplicates",
  "salary_visible": "Salary info is visible",
  "search_placeholder_name_phone_links_email": "Name, phone, links, email",
  "set_priority": "Set priority",
  "setup_fields_for_career_site": "Setup fields for the career site",
  "setup_job_fields_description": "Choose which fields are mandatory for the candidate",
  "setup_job_fields_title": "Configure candidate application form",
  "setup_job_page": "Setup job page",
  "share_candidates_salary_info": "Share candidates salary info",
  "share_candidates_salary_info_caption": "Makes salary info visible for this user, regardless of global privacy settings",
  "share_offer": "Share offer",
  "shareable_link_offer_description": "Make offer publicly available via link",
  "similar_are_different": "No, these are different people",
  "similar_candidate": "Similar candidate",
  "similar_candidate_found_description": "Please review profiles and decide are they same persons or not",
  "similar_candidate_found_title": "Perhaps a similar record in database exists",
  "skills": "Skills",
  "sorting_a_z": "Sort A-Z",
  "sorting_by_priority": "Sort by priority",
  "sorting_job_match": "Best job match",
  "sorting_most_recent": "Most recent activity",
  "sorting_newest_candidates": "Newest candidates",
  "sources": "Sources",
  "stage": "Stage",
  "stage_add": "Add stage",
  "stages": "Stages",
  "stages_description": "Ensure that the funnel stages reflect the actual business processes in the company",
  "stakeholders": "Stakeholders",
  "stakeholders_involved": "Stakeholders involved",
  "tag": "Tag",
  "tag_add": "Add tag",
  "tags": "Tags",
  "time_limit_title": "Time limit (days)",
  "time_on_stage": "Time on stage",
  "total_time_on_current_stage": "Total time on current stage",
  "try_broadening_filters": "Let’s try broadening the filters — we might find a candidate",
  "unassign_from_job_description": "Are you sure you want unassign from?",
  "unassign_from_job_title": "Unassign from Job",
  "upload_cv_file": "Choose CV files",
  "upload_cv_file_drag_and_drop_description": "Accepts up to 10 (pdf, doc, docx, rtf, odt) files",
  "upload_files": "Upload files",
  "upload_success_count": "Upload completed. {count} new candidates created!",
  "uploading_cvs": "Uploading CVs",
  "uploading_cvs_count": "Uploading {count} new CVs",
  "use_ai_description": "Use AI to score candidates based on their CV and job requirements",
  "use_ai_title": "Use AI to score candidates",
  "view_original": "View original",
  "view_in_modal": "View in modal",
  "~": "~"
}
